<ul class="link-menu-container">
    <li class="link-menu-item" *ngFor="let item of dataSource" [class]="item.cssClass"
        [ngClass]="{'link-menu-item-active':item.value==selectedItem?.value,'link-menu-item-disabled':item.disabled}" >
        <a (click)="itemClick(item,$event)">{{item.name}}</a>
    </li>
</ul>